export const dismissNudgeTooltip = "savlNe";
export const mailListNudgeMoreOptionsTooltip = "S_FMlb";
export default {dismissNudgeTooltip,mailListNudgeMoreOptionsTooltip};